import { React, createContext, useState, useEffect } from "react";
import axios from "axios";

export const UserContext = createContext({});

export function UserContextProvider({ children }) {
  const [user, setUser] = useState(null);
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios
      .get("/news")
      .then(({ data }) => {
        setNews(data);
      })
      .catch((err) => {
        console.log(err);
      });

    if (!user) {
      axios
        .get("/auth/profile")
        .then(({ data }) => {
          setUser(data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user]);

   const logout = async () => {
    try {
      await axios.get("/auth/logout");
      setUser(null);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Logout failed"
      };
    }
  };
  return (
    <UserContext.Provider value={{ user, setUser, news, setNews, logout }}>
      {children}
    </UserContext.Provider>
  );
}
